import { render, staticRenderFns } from "./oportunidades.vue?vue&type=template&id=2669a53e&scoped=true"
import script from "./oportunidades.vue?vue&type=script&lang=js"
export * from "./oportunidades.vue?vue&type=script&lang=js"
import style0 from "./oportunidades.vue?vue&type=style&index=0&id=2669a53e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2669a53e",
  null
  
)

export default component.exports